import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../contexts/ThemeContext';
import { spacing } from '../theme';

export const ThemeToggle: React.FC = () => {
  const { themeMode, setThemeMode, colors } = useTheme();

  return (
    <TouchableOpacity
      style={[styles.button, { borderColor: colors.border, backgroundColor: colors.background.surface }]}
      onPress={() => setThemeMode(themeMode === 'dark' ? 'light' : 'dark')}
      activeOpacity={0.7}
    >
      <Ionicons
        name={themeMode === 'dark' ? 'moon-outline' : 'sunny-outline'}
        size={16}
        color={colors.primary}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: 32,
    height: 32,
    borderRadius: spacing.borderRadius.md,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
